import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MainLogo from '../MainLogo';
import './style.scss';

const PrincipalNavbar = ({ children }) => (
  <Navbar bg="light" expand="lg" fixed="top">
    <Navbar.Brand as={Link} to="/">
      <MainLogo />
    </Navbar.Brand>
    <Navbar.Toggle className="ml-auto d-none" aria-controls="basic-navbar-nav" />
    {children}
  </Navbar>
);

export default PrincipalNavbar;
